// extracted by extract-css-chunks-webpack-plugin
module.exports = {"main_nav":"main_nav-3qv7pzPk","user":"user-3-sV8fty","box":"box-3KyENnSe","ad":"ad-32f59mRF","search":"search-9SpiKmSS","logo":"logo-3r9XXAro"};